import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import PossibilitySection from '../Components/work/PossibilitySection'
import WorkWithReach from '../Components/work/WorkWithReach'
import GreatPlaceToWorkSection from '../Components/work/GreatPlaceToWorkSection'
import WorkWithPurposeSection from '../Components/work/WorkWithPurposeSection'
import NextBestSelfSection from '../Components/work/NextBestSelfSection'
import { Helmet } from "react-helmet-async";

function WorkingHere() {
    return (
        <div>
            <Helmet>
    <title>
        Working at Mobikode | Careers, Culture & Opportunities
    </title>

    <meta
        name="description"
        content="Discover what it's like working at Mobikode. Explore our workplace culture, career opportunities, purpose-driven work, and an environment where people can learn, grow, and build their best careers."
    />

    <meta
        name="keywords"
        content="Working at Mobikode, Mobikode Careers, Mobikode Jobs, Work Culture, Careers at Mobikode, Life at Mobikode, Technology Careers, IT Jobs, Software Developer Jobs, Digital Technology Careers, Career Opportunities, Work Culture in IT"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/working-here"
    />

    <meta
        property="og:title"
        content="Working at Mobikode | Careers, Culture & Opportunities"
    />

    <meta
        property="og:description"
        content="Explore the culture, opportunities, and purpose-driven environment at Mobikode where talented people come together to learn, grow, innovate, and build meaningful digital solutions."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/working-here"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/products/bg2.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Working at Mobikode | Careers, Culture & Opportunities"
    />

    <meta
        name="twitter:description"
        content="Learn about working at Mobikode, our culture, career opportunities, and the environment we create for people to grow and do meaningful work."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/products/bg2.png"
    />
</Helmet>
            <WhoHero
                title="Working Here"
                text="Technology. Transformation. Trust."
                imgData="/assets/products/bg2.png"
            />
            <PossibilitySection />
            {/* <WorkWithReach /> */}
            {/* <GreatPlaceToWorkSection /> */}
            <WorkWithPurposeSection />
            {/* <NextBestSelfSection /> */}
        </div>
    )
}

export default WorkingHere
